import React from 'react';
import { useAbout } from '../../context/CMSContext';

interface AboutSectionProps {
  forceShow?: boolean;
}

const AboutSection: React.FC<AboutSectionProps> = ({ forceShow = false }) => {
  const about = useAbout();
  if (!about.enabled) return null;

  return (
    <section id="about" className={`${forceShow ? '' : 'hidden md:block'} py-12 bg-[#f5f3ee]`}>
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center">
            <span className="text-gold-700 text-sm font-bold uppercase tracking-[0.2em]">{about.sectionTagline}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 mb-6">{about.sectionTitle}</h2>
            <p className="text-slate-600 leading-relaxed mb-8 whitespace-pre-line">{about.description}</p>

          </div>
      </div>
    </section>
  );
};

export default AboutSection;
